import { IExpenditure } from "types/interfaces/Expenditure";

export const isExpenditureSharedToMyContractor = (expenditure: IExpenditure) => {
  return !expenditure?.is_shared && expenditure?.providers?.length;
};

export const isExpenditureSharedToMeButCantAddInterval = (expenditure: IExpenditure) => {
  return expenditure?.is_shared && ["sent", "verification"].includes(expenditure?.shared_status!);
};
